var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
export var Avatar = function (_a) {
    var initials = _a.initials, url = _a.url, _b = _a.size, size = _b === void 0 ? 36 : _b, className = _a.className, rest = __rest(_a, ["initials", "url", "size", "className"]);
    // For interactive demos, the size values come in as strings
    // so a double equal is preferred here.
    var displayInitials = initials === null || initials === void 0 ? void 0 : initials.substring(0, size === 24 ? 1 : 2).toUpperCase();
    return (_jsxs("figure", __assign({ className: classNames("eds-avatar", "eds-avatar--size-".concat(size), className) }, rest, { children: [url && (_jsx("div", { className: "eds-avatar__image", style: { backgroundImage: "url(".concat(url, ")") } })), _jsx("figcaption", { children: displayInitials })] })));
};
